<template>
  <div>
    <div
      v-loading.fullscreen.lock="loading"
      element-loading-custom-class="LoadingSass"
      element-loading-spinner="el-icon-loading"
      element-loading-text="加载中"
      element-loading-background="rgba(0, 0, 0, 0.7)"
      style="width:100%;"
    >
      <div class="container">
        <!-- 1.行业热点 -->
        <template>
          <div>
            <!-- 1.1 标题-行业热点 -->
            <div class="title">
              <div class="titleLeft">
                <img src="../../assets/images/breakCircle/titleAround.png" alt>
                <span class="spanText">行业热点</span>
                <!-- 1.1.1 新增更新时间 -->
                <div style="marginLeft: 12px;font-size: 14px; color: #999999; lineHeight: 20px;">
                  <span>数据更新时间：</span>
                  <span>{{ this.updateTime }}</span>
                </div>
              </div>

              <!-- 1.2 行业热点-展开&收起 -->
              <div
                class="titleRight"
                @click="handleOpenSystemOne(index)"
                v-show="this.hotspotList.length>4"
              >
                <div class="text">{{ openSystem? "展开全部" : "收起全部" }}</div>
                <div class="icon">
                  <i :class="openSystem ? 'el-icon-arrow-down': 'el-icon-arrow-up'"></i>
                </div>
              </div>
            </div>

            <!-- 1.3 行业热点-列表 -->
            <div class="picOne">
              <el-row :gutter="20">
                <template v-for="(item, index) in hotspotList">
                  <el-col :span="6" :key="index + '@'">
                    <template v-if="item.isHide">
                      <div class="box1">
                        <!-- 懒加载 -->
                        <img @click="jumpLink(item)" v-lazy="item.picUrl" alt>
                        <el-popover
                          v-if="item.title.length > 15"
                          placement="top-start"
                          trigger="hover"
                          width="200"
                          :content="item.title"
                        >
                          <div
                            @click="jumpLink(item)"
                            slot="reference"
                            class="hotTitle"
                          >{{ item.title }}</div>
                        </el-popover>
                        <div
                          v-else
                          @click="jumpLink(item)"
                          slot="reference"
                          class="hotTitle"
                        >{{ item.title }}</div>
                      </div>
                    </template>
                  </el-col>
                </template>
              </el-row>
            </div>
          </div>
        </template>

        <!-- 2.行业破圈解法 -->
        <template>
          <div class="title" style="marginBottom: 16px; marginTop: 40px;">
            <!-- 2.1 标题-行业破圈解法 -->
            <div class="titleLeft">
              <img src="../../assets/images/breakCircle/titleAround.png" alt>
              <span class="spanText">行业破圈解法</span>
            </div>

            <!-- 2.2 行业破圈解法-展开&收起 -->
            <div
              class="titleRight"
              @click="handleOpenSystemTwo(index)"
              v-show="this.solutionList.length>4"
            >
              <div class="text">{{ openSystemTwo ? "收起全部" : "展开全部" }}</div>
              <div class="icon">
                <i :class="openSystemTwo ? 'el-icon-arrow-up': 'el-icon-arrow-down'"></i>
              </div>
            </div>
          </div>

          <!-- 2.3 行业破圈解法-列表 -->
          <div class="picTwo">
            <el-row :gutter="20">
              <template v-for="(item, index) in solutionList">
                <el-col :span="12" :key="index + '@'">
                  <template v-if="item.isHide">
                    <div class="box2" style="marginBottom:20px;">
                      <!-- <img :src="item.picUrl" alt> -->
                      <!-- 懒加载 -->
                      <img
                        @click="jumpSltLink(item)"
                        v-lazy="item.picUrl"
                        alt
                        style="cursor: pointer;"
                      >
                      <div class="text">
                        <div class="minTitle">
                          <div class="string"></div>
                          <div class="text1">推荐解法</div>
                          <el-tooltip
                            v-if="item.remindText"
                            placement="top"
                            width="200"
                            effect="light"
                            trigger="hover"
                            :content="item.remindText"
                          >
                            <img src="../../assets/images/breakCircle/askMark.png" alt class="img">
                          </el-tooltip>
                        </div>

                        <template v-for="(it, index) in item.industrySolutionDetailList">
                          <div class="contents" :key="index + '@'">
                            <div class="contents1">
                              <el-popover
                                v-if="it.title.length > 8"
                                placement="top-start"
                                trigger="hover"
                                width="200"
                                :content="it.title"
                              >
                                <div slot="reference" class="breakTitle">{{ it.title }}</div>
                              </el-popover>
                              <div v-if="it.title.length <= 8" class="breakTitle">{{ it.title }}</div>
                            </div>
                            <div class="contents2">
                              <el-popover
                                v-if="it.description.length > 15"
                                placement="top-start"
                                trigger="hover"
                                width="200"
                                :content="it.description"
                              >
                                <div slot="reference" class="breakDes">{{ it.description }}</div>
                              </el-popover>
                              <div
                                v-if="it.description.length <= 15"
                                class="breakDes"
                              >{{ it.description }}</div>
                            </div>
                            <div class="btn" @click="goJump(item,it)">
                              GO
                              <i class="el-icon-arrow-right el-icon--right"></i>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </template>
                </el-col>
              </template>
            </el-row>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {
  gethotspotList,
  getSolutionList,
  getClickData,
  toJHK,
  getSeller
} from "../../api/yusms/industryBreakCircle.js";
import Moment from "moment";
export default {
  name: "breakCircle",
  data() {
    return {
      isOrderHd: false, //京获客资格
      updateTime: "",
      show1: true,
      // loading加载
      loading: true,
      // 展开&收起
      openSystem: true,
      openSystemTwo: true,
      // 行业热点列表
      hotspotList: [],
      // 行业破圈解法列表
      solutionList: [],
      index: ""
    };
  },
  props: {},
  computed: {},
  created() {},
  mounted() {
    // 展开&收起
    this.openSystem = false;
    this.openSystemTwo = false;
    // 获取行业热点列表
    this.gethotspotList();
    // 获取行业破圈解法列表
    this.getSolutionList();
    this.handleOpenSystemOne();
    // 埋点
    this.buriedPoint(1, "行业破圈", "行业专区", "行业破圈");
    // 获取京获客资格
    this.getSellers();
  },
  methods: {
    // 0 新增：获取京获客资格
    getSellers() {
      getSeller().then(res => {
        if (res.code == 1) {
          // console.log(res,'111111111111');
          this.isOrderHd = res.data.isOrderHd;
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    //1.1 展开&收起(行业热点)
    handleOpenSystemOne(index) {
      this.openSystem = !this.openSystem;
      this.hotspotList = this.hotspotList.map((item, num) => {
        let obj = item;
        obj.openSystem = !item.openSystem;
        if (!obj.openSystem) {
          // 展开
          obj.isHide = num <= 3 ? true : false;
        } else {
          // 收起
          obj.isHide = true;
        }
        return obj;
      });
    },

    // 1.2 展开&收起（行业破圈）
    handleOpenSystemTwo(index) {
      this.openSystemTwo = !this.openSystemTwo;
      this.solutionList = this.solutionList.map((item, num) => {
        let obj = item;
        obj.openSystemTwo = !item.openSystemTwo;

        if (!obj.openSystemTwo) {
          // 展开
          obj.isHide = num <= 3 ? true : false;
        } else {
          // 收起
          obj.isHide = true;
        }
        return obj;
      });
    },
    // 2.获取行业热点列表
    gethotspotList() {
      gethotspotList().then(res => {
        if (res.data && res.code == 1) {
          this.hotspotList = res.data.hotspotList;
          this.updateTime = Moment(res.data.updateTime).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          if (this.hotspotList && this.hotspotList.length > 0) {
            this.hotspotList.forEach((item, i) => {
              item.isHide = i <= 3 ? true : false;
            });
          }
        }
        this.loading = false;
      });
    },

    // 3.获取行业破圈解法列表
    getSolutionList() {
      getSolutionList().then(res => {
        if (res.data && res.code == 1) {
          this.solutionList = res.data.solutionList;
          if (this.solutionList && this.solutionList.length > 0) {
            this.solutionList.forEach((item, i) => {
              item.isHide = i <= 3 ? true : false;
            });
          }
        }
        this.loading = false;
      });
    },
    //4. 获取点击次数(行业热点)
    getClickNum(type, id) {
      let params = {
        type,
        industryId: id
      };
      getClickData(params)
        .then(res => {})
        .catch(() => {});
    },
    // 5.行业热点-图片、标题跳转
    jumpLink(val) {
      this.getClickNum(2, val.id);
      window.open(val.jumpLink, "_blank");
    },
    // 6.Go跳转
    goJump(url, urlit) {
      this.getClickNum(3, url.id);
      // 判断是否为京获客链接
      if (urlit.linkType == 1) {
        //如果是京获客链接
        if (this.isOrderHd) {  // 判断是否有购买jhk
          toJHK({ url: urlit.jumpLink }).then(res => {
            if (res.code == 1) {
              let jhk_link = res.data;
              window.open(jhk_link, "_blank");
            } else {
              this.$message.warning(res.message);
            }
          });
        } else { //没有买jhk或者过期
          window.open("/jhkGuide", "_blank");
          // this.buriedPoint(1, "引导订购京获客页面", "行业专区", "行业破圈");
        }
      } else {  //如果不是京获客链接
        window.open(urlit.jumpLink, "_blank");
      }
    },
    // 7.行业破圈解法-图片跳转
    jumpSltLink(val) {
      this.getClickNum(4, val.id);
      window.open(val.jumpLink, "_blank");
    },
    // 8.跳转到京获客
    junkHDredirect() {
      hdRedirect()
        .then(res => {})
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss">
//修改Loading样式
.LoadingSass {
  .el-loading-spinner i {
    color: #ffffff !important;
    font-size: 20px;
  }
  .el-loading-spinner .el-loading-text {
    color: #ffffff !important;
    padding: 10px 0;
    font-size: 16px;
  }
}
</style>

<style lang='scss' scoped>
body {
  background-color: #fbfbff;
}

* {
  margin: 0;
  padding: 0;
}

.container {
  // background-color:#FBFBFF;
  width: 1200px;
  height: 300px;
  margin: 0 auto;
  text-align: center;
  // margin-bottom: 10px;

  .title {
    display: flex;
    justify-content: space-between;
    margin-top: 24px;

    .titleLeft {
      display: flex;

      img {
        width: 20px;
        height: 20px;
      }

      .spanText {
        font-size: 20px;
        color: #333333;
        font-weight: bold;
        margin-left: 4px;
      }
    }

    .titleRight {
      display: flex;
      // justify-content: flex-end;
      font-size: 14px;
      color: #999999;
      height: 16px;
      line-height: 20px;
      cursor: pointer;

      .text {
        font-size: 14px;
        color: #999999;
        line-height: 24px;
      }

      .icon {
        width: 24px;
        height: 24px;
        opacity: 1;
        color: #999999;
        text-align: center;
        line-height: 24px;
        margin-left: 2px;
      }
    }
  }

  .box1 {
    background: #fff;
    width: 285px;
    height: 174px;
    margin-top: 16px;
    border-radius: 8px 8px 8px 8px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;

    img {
      width: 285px;
      height: 130px;
      border-radius: 8px 8px 0px 0px;
      opacity: 1;
      //或者background-size:100%;
      background-size: contain;
      cursor: pointer;
    }
    .hotTitle {
      margin-left: 12px;
      margin-top: 12px;
      text-align: left;
      font-size: 14px;
      color: #333333;
      line-height: 16px;
      cursor: pointer;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      -webkit-line-clamp: 1;
    }

    div:hover {
      color: #6461e7;
    }
  }

  .box2 {
    width: 590px;
    height: 328px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    border: 1px solid #f5f3ff;
    padding-top: 12px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;

    img {
      width: 566px;
      height: 150px;
      border-radius: 4px 4px 4px 4px;
    }

    .text {
      margin: 12px 12px 0 12px;
      width: 566px;
      overflow: hidden;

      .minTitle {
        display: flex;
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        border-radius: 2px 2px 2px 2px;
        text-align: left;
        padding-left: 3px;
        height: 16px;

        .string {
          width: 4px;
          height: 16px;
          background: #6461e7;
          border-radius: 2px 2px 2px 2px;
          margin-right: 4px;
        }

        .text1 {
          font-size: 16px;
          font-weight: bold;
        }

        .img {
          width: 14px;
          height: 14px;
          margin-left: 4px;
          margin-top: 2px;
        }
      }

      .contents {
        display: flex;
        margin-top: 14px;
        line-height: 15px;
        width: 566px;
        overflow: hidden;

        .contents1 {
          font-size: 14px;
          font-weight: bold;
          color: #6461e7;
          line-height: 25px;

          .breakTitle {
            // width: 112px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            -webkit-line-clamp: 1;
          }
        }

        .contents2 {
          flex: 1 !important;
          margin-left: 12px;
          font-size: 13px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          flex: 1;
          text-align: left;
          line-height: 25px;
          overflow: hidden;

          .breakDes {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            -webkit-line-clamp: 1;
          }
        }

        .btn {
          width: 47px;
          height: 25px;
          background: #ffffff;
          border-radius: 4px 4px 4px 4px;
          opacity: 1;
          border: 1px solid #6461e7;
          font-size: 12px;
          line-height: 25px;
          color: #6461e7;
          cursor: pointer;
          margin-left: 30px;
          padding-left: 8px;

          i {
            position: relative;
            left: -4px;
          }
        }

        .btn:hover {
          background: #6461e7;
          color: #ffffff;
          font-size: 12px;
          font-weight: 400;
        }
      }
    }
  }
}

.box1:hover,
.box1:focus {
  -webkit-box-shadow: 0px 0px 30px 0px rgba(100, 97, 231, 0.15);
  box-shadow: 0px 0px 30px 0px rgba(100, 97, 231, 0.15);
  -webkit-transform: translate(0, -12px);
  transform: translate(0, -12px);
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

.box2:hover,
.box2:focus {
  -webkit-box-shadow: 0px 0px 30px 0px rgba(100, 97, 231, 0.15);
  box-shadow: 0px 0px 30px 0px rgba(100, 97, 231, 0.15);
  -webkit-transform: translate(0, -12px);
  transform: translate(0, -12px);
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}
</style>